import { Alert, Button, ConfigProvider, Flex } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

type NewInvoicingPageToggleProps = {
  useNewInvoicing: boolean
  onToggle?: (useNewInvoicing: boolean) => void
}

const NewInvoicingPageToggle = ({ useNewInvoicing, onToggle }: NewInvoicingPageToggleProps) => {
  if (!useNewInvoicing) {
    return (
      <Alert
        type="warning"
        showIcon
        message={
          <Flex align="center" justify="space-between">
            <span><strong>Classic invoicing will be retired on November 11.</strong></span>
            <Button type="primary" onClick={() => onToggle?.(true)}>
              Switch to New Invoicing
            </Button>
          </Flex>
        }
        style={{ marginBottom: '2em' }}
      />
    )
  }

  return (
    <Alert
      type="info"
      showIcon
      message={
        <Flex align="center" justify="space-between">
          <span>You're looking at the early version of batch invoicing. Give us your feedback!</span>
          <Flex gap={8}>
            <Button onClick={() => onToggle?.(!useNewInvoicing)}>
              Switch to Classic Invoicing
            </Button>
            <ConfigProvider theme={{ token: { colorPrimary: '#fa8c16' } }}>
              <Button
                type="primary"
                icon={<FontAwesomeIcon icon={faStar} />}
                onClick={() => window.posthog.displaySurvey('019d690c-854d-0000-d727-cc25e74de2e3', {
                  ignoreConditions: true,
                  ignoreDelay: true,
                })}
              >
                Give Feedback
              </Button>
            </ConfigProvider>
          </Flex>
        </Flex>
      }
      style={{ marginBottom: 0 }}
    />
  )
}

export default NewInvoicingPageToggle
